<template>
    <a-modal
        title="添加权限"
        :width="1090"
        :visible="visible"
        :confirmLoading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel"
        cancelText="关闭"
        okText="确认">
    <a-transfer
        showSearch
        :data-source="mockData"
        :titles="['权限列表', '分配权限']"
        :listStyle="{
            width: '500px',
            height: '600px',
        }"
        :locale="{ itemUnit: '项', itemsUnit: '项', notFoundContent: '列表为空', searchPlaceholder: '请输入搜索内容' }"
        :target-keys="targetKeys"
        :selected-keys="selectedKeys"
        :render="item => item.title"
        @change="handleChange"
        @selectChange="handleSelectChange"
        @search="search"
        />
    </a-modal>
</template>

<script>
export default {
  name: 'AddPermissionModal',
  data () {
    return {
      roleId: '',
      visible: false,
      confirmLoading: false,
      mockData: [],
      targetKeys: [],
      selectedKeys: []
    }
  },
  mounted: function () {
  },
  methods: {
    show (id) {
      this.roleId = id
      this.baseAPI.axiosData('/api-u/permissions?size=9999&current=1','get',{}).then(res => {
        this.mockData=res.data.records.map(item => { return { key: item.id, title: item.name } })
      })
      this.baseAPI.axiosData('/api-u/roles/'+id+'/permissions','get',{}).then(res=>{
        this.targetKeys=res.data.map(item => item.id)
      })
      this.visible = true
    },
    handleCancel () {
      this.visible = false
    },
    handleChange(nextTargetKeys) {
      this.targetKeys = nextTargetKeys;
    },
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];
    },
    search (direction, value) {
      return this.mockData.filter(item => item.title.indexOf(value.trim()) > 0)
    },
    handleOk(){
      const _this = this
      this.$confirm({
        title: '确认操作',
        content: '是否添加权限?',
        okText: '确认',
        cancelText: '取消',
        onOk: function () {
          _this.confirmLoading = true
          _this.baseAPI.axiosData('/api-u/roles/'+_this.roleId+'/permissions','post',_this.targetKeys).then(res => {
            _this.$notification.success({
              message: '提示',
              description: res.message || '添加权限成功',
              duration: 3
            })
            _this.confirmLoading = false
            _this.$emit('ok')
            _this.visible = false
          }).catch(err => {
            _this.$notification.error({
              message: '错误',
              description: ((err.response || {}).data || {}).message || '添加权限失败',
              duration: 3
            })
            _this.confirmLoading = false
            _this.handleCancel()
          })
        }
      })
    }
  }
}
</script>
